import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import LiveTextWidgetComponent from './js/live-text-widget.component';
import LiveTextWidgetListing from './js/live-text-widget-listing';

ComponentsFactory.getInstance().define('live-text-widget', LiveTextWidgetComponent);

export {
    LiveTextWidgetListing
};
